import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import logo from "../assets/images/logo.svg";
import profileIcon from "../assets/images/userres.svg";
import profileIcon2 from "../assets/images/downres.svg";
import Cookies from "js-cookie";
import { useFetchUserByIdQuery } from "../../src/components/SettingsDashboard/Hooks";
import {
  toggleExplore,
  toggleMobileExplore,
  setHoveredOption,
  setActiveSubOption,
  toggleNav,
  togglePopup,
} from "../store/features/modalSlice";
import { clearUser } from "../store/features/authSlice";
import MobileNavigation from "./navbar/MobileNavigation";

/**@Icons */
import { FiMenu } from "react-icons/fi";
import { RxCross2 } from "react-icons/rx";
import NavPopup from "./shared/NavPopup";
import { getURLParams } from "../utils/utilityFunctions";

const startOptions = [
  {
    name: "Celebrations",
    filterKey: "eventTypes",
    subKey: [
      "Weddings",
      "Weddings",
      "Dining",
      "Social Gathering",
      "Dining",
      "Social Gathering",
      "Milestone Birthdays",
      "Tea Party/Showers",
      "Tea Party/Showers",
      "Teen/Children",
      "Special Big Events",
      "Cultural Celebrations",
    ],
    subOptions: [
      "Wedding Ceremony",
      "Wedding Reception",
      "Anniversary Party",
      "Engagement",
      "Graduation Party",
      "New Years Eve Party",
      "Birthday Party",
      "Baby Shower",
      "Bridal Shower",
      "Teen Party",
      "Gender Reveals",
      "Christmas Party",
      // "Cultural Celeberations",
    ],
  },
  {
    name: "Art & Culture",
    filterKey: "eventTypes",
    subKey: [
      "Filming, Photography & Media",
      "Art Spaces",
      "Art Spaces",
      "Performances & Exhibitions",
      "Performances & Exhibitions",
      "Performances & Exhibitions",
    ],
    subOptions: [
      "Photoshoot",
      "Art Exhibitions",
      "Pop Up Event",
      "Concert",
      "Fashion Show",
      "Live Performance",
    ],
  },
  {
    name: "Corporate",
    filterKey: "eventTypes",
    subKey: [
      "Conference/Seminars",
      "Conference/Seminars",
      "Conference/Seminars",
      "Conference/Seminars",
      "Conference/Seminars",
      "Corporate Events",
      "Corporate Events",
      "Corporate Events",
      "Corporate Events",
      "Corporate Events",
    ],
    subOptions: [
      "Conference",
      "Exhibitions",
      "Meetings",
      "Networking",
      "Product Launch",
      "Team Building",
      "Training Program",
      "Office Party",
      "Corporate Gala Dinner",
      "Corporate Retreat",
    ],
  },
  {
    name: "City",
    filterKey: "city",
    subOptions: [
      "Dubai",
      "Abu Dhabi",
      "Ras Al Khaimah",
      "Sharjah",
      "Fujairah",
      "Ajman",
      "Umm Al Quwain",
    ],
  },
  {
    name: "Venue Type",
    filterKey: "venueTypes",
    subOptions: [
      "Beach",
      "Desert",
      "Boats & Yachts",
      "Venue with onsite activities",
      "Sports venue",
      "Exhibitions Halls",
      "Meeting room",
      "Kids play area",
      "Restaurant",
      "Ballroom",
      "Blank canvas",
      "Auditorium",
      "Warehouse",
      "Indoor",
      "Outdoor",
      "Indoor & Outdoor",
    ],
  },
  {
    name: "Hotel Stay + Venue",
    filterKey: "hotelStayAndVenue",
    subOptions: [
      "Airport Hotel",
      "All-Inclusive Resort",
      "Beach Hotel",
      "Boutique Hotel",
      "Budget Hotel",
      "Business Hotel",
      "Casino Hotel",
      "City Hotel",
      "Desert Hotel",
      "Eco-friendly Hotel",
      "Floating Hotel",
      "Glamping Hotel",
      "Golf Resorts",
      "Heritage Hotel",
      "Historic Hotel",
      "Island Hotel",
      "Luxury Hotel",
      "Resort Hotel",
      "Safari Hotel",
      "Wellness Hotel",
    ],
  },
];

function ResponsiveAppBar({ filters, setFilters }) {
  const invitedBy = localStorage.getItem("invitedBy");
  const vendorId = invitedBy || localStorage.getItem("vendorId");
  const {
    data: userData,
    isLoading: isFetchingUser,
    error,
  } = useFetchUserByIdQuery(vendorId);

  // Extract user from fetched data
  const user = userData?.vendor;
  const [anchorElProfile, setAnchorElProfile] = useState(null);
  const [showExploreOptions, setShowExploreOptions] = useState(false);
  const [params, setParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const dropdownRef = useRef(null);
  const isFirstCall = useRef(true);
  const {
    openExplore,
    openMobileExplore,
    hoveredOption,
    activeSubOption,
    openNav,
    openPopup,
    selectedSubOptions,
    selectedName,
  } = useSelector((state) => state.modal);
  const isLoggedIn = !!localStorage.getItem("accessToken");
  if ((openMobileExplore, toggleMobileExplore)) {
  }

  const setShowExploreOptionsHandler = () => {
    if (
      location.pathname === "/" ||
      location.pathname.includes("/cancellation-policy") ||
      location.pathname.includes("/privacy-policy") ||
      location.pathname.includes(
        "/terms&conditions" || location.pathname.includes("/terms-of-use")
      ) ||
      location.pathname.includes("/list-venues") ||
      location.pathname.includes("/faqs")
    ) {
      setShowExploreOptions(true);
    }
  };


  useEffect(() => {
    setShowExploreOptionsHandler();
  }, []);

  useEffect(() => {
    // Add event listener to close Explore when clicking outside
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        openExplore // Only close if open
      ) {
        dispatch(toggleExplore());
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dispatch, openExplore]);

  const handleOpenProfileMenu = (event) => {
    setAnchorElProfile(event.currentTarget);
  };

  const handleCloseProfileMenu = () => {
    setAnchorElProfile(null);
  };

  const handleLogout = () => {
    Cookies.remove("token", { path: "/" });
    localStorage.clear();
    dispatch(clearUser());
    navigate("/");
  };

  const handleSelectOption = (category, option) => {
    setFilters((prevFilters) => {
      const newFilters =
        category === "hotelStayAndVenue"
          ? { ...prevFilters, hotelType: [option] }
          : { ...prevFilters, [category]: [option] };

      dispatch(setHoveredOption(null));
      dispatch(setActiveSubOption(null));

      if (isFirstCall.current) {
        isFirstCall.current = false;
      } else {
        if (category === "hotelStayAndVenue") {
          navigate(`/listing/2?${getURLParams(newFilters)}`, { replace: false });
        } else {
          navigate(`/listing/1?${getURLParams(newFilters)}`, { replace: false });
        }
      }

      return newFilters;
    });
  };

  // if user on success page (means he is new user should route to onboarding) else list-venues
  const handleNavigation = () => {
    if (
      location.pathname === "/success" ||
      location.pathname.startsWith("/success/")
    ) {
      navigate("/onboarding");
    } else {
      navigate("/list-venues");
    }
  };

  const handleToggleNavigation = () => {
    dispatch(toggleNav());
    if (openPopup) dispatch(togglePopup({ isOpen: false }));
    if (openMobileExplore) dispatch(toggleMobileExplore());
  };

  console.log("Filters in ResponsiveAppBar:", filters);

  return (
    <>
      <AppBar position={openNav ? "fixed" : "static"}>
        <Container maxWidth="xl">
          <Toolbar
            disableGutters
            sx={{ width: "100%", zIndex: 10 }}
            className="h-20"
          >
            <div style={{ display: "block", width: "auto" }}>
              <a href="/">
                <Box
                  component="img"
                  src={logo}
                  alt="Logo"
                  sx={{ display: "block", width: "100%" }}
                  className="mx-2"
                />
              </a>
            </div>

            <Box sx={{ flexGrow: 1 }} />

            <Box
              sx={{ display: "flex", alignItems: "center" }}
              ref={dropdownRef}
            >
              {showExploreOptions && (
                <div
                  className="hidden lg:flex items-center gap-2 cursor-pointer relative mr-7"
                  onClick={() => dispatch(toggleExplore())}
                >
                  <h1 className="text-white">Explore</h1>
                  {openExplore ? (
                    <IoMdArrowDropup className="text-white text-lg" />
                  ) : (
                    <IoMdArrowDropdown className="text-white text-lg" />
                  )}
                  {openExplore && (
                    <div
                      className="bg-white text-black rounded-lg absolute top-9 left-0 shadow-xl p-2 min-w-[200px] z-[9999]"
                      onMouseLeave={() => {
                        dispatch(setHoveredOption(null));
                        dispatch(setActiveSubOption(null));
                      }}
                    >
                      {startOptions.map((e, i) => (
                        <div
                          key={i}
                          className="relative"
                          onMouseEnter={() => {
                            dispatch(setHoveredOption(i));
                            dispatch(setActiveSubOption(i));
                          }}
                          onMouseLeave={(e) => {
                            // Check if mouse is moving to child menu
                            const relatedTarget = e.relatedTarget;
                            if (!relatedTarget || !e.currentTarget.contains(relatedTarget)) {
                              dispatch(setHoveredOption(null));
                              dispatch(setActiveSubOption(null));
                            }
                          }}
                        >
                          <div
                            className={`py-2 px-2 w-full flex-1 text-sm flex items-center justify-between gap-2 rounded-md hover:bg-[#FFF5F5] ${hoveredOption === i ? "bg-[#FFF5F5]" : ""
                              }`}
                          >
                            {e.name}
                            {e.subOptions && (
                              <MdOutlineKeyboardArrowRight className="text-lg flex-shrink-0" />
                            )}
                          </div>

                          {activeSubOption === i && e.subOptions && (
                            <div
                              className={`z-[9999]child-menu bg-white rounded-md absolute right-full top-0 mr-1 overflow-y-auto max-h-[80vh] grid ${i === 1
                                ? "grid-cols-1 xl:w-[32rem] w-[28rem]"
                                : i === 0
                                  ? "grid-cols-2 xl:w-[22rem] w-[20rem]"
                                  : i === 4
                                    ? "grid-cols-3 xl:w-[40rem] w-[32rem]"
                                    : "grid-cols-2 xl:w-[22rem] w-[20rem]"
                                } shadow-lg`}
                              style={{ zIndex: 10000 }} // Higher than parent
                              onMouseEnter={() => {
                                dispatch(setHoveredOption(i));
                                dispatch(setActiveSubOption(i));
                              }}
                              onMouseLeave={() => {
                                dispatch(setHoveredOption(null));
                                dispatch(setActiveSubOption(null));
                              }}
                            >
                              {e.subOptions.map((subOption, subIndex) => (
                                <div
                                  key={subIndex}
                                  className="px-4 py-3 rounded-md text-sm hover:bg-[#FFF0F0] cursor-pointer whitespace-nowrap"
                                  onClick={() => {
                                    setFilters({
                                      search: "",
                                      city: "",
                                      eventTypes: [],
                                      venueTypes: [],
                                      venueHire: [],
                                      standingGuests: "",
                                      sittingGuests: "",
                                      catering: [],
                                      venueSettings: [],
                                      amenities: [],
                                      menus: [],
                                      area: [],
                                      venueRental: { min: "", max: "" },
                                      minSpendPerPerson: { min: "", max: "" },
                                      minSpendPerEvent: { min: "", max: "" },
                                    });

                                    if (e.filterKey === "eventTypes") {
                                      const subKeyValue = startOptions[i].subKey[subIndex];
                                      handleSelectOption(e.filterKey, { [subKeyValue]: [subOption] });
                                    } else {
                                      handleSelectOption(e.filterKey, subOption);
                                    }
                                  }}
                                >
                                  {subOption}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
              {location.pathname !== "/onboarding" && (
                <div
                  className="cursor-pointer hidden lg:flex"
                  onClick={handleNavigation}
                  style={{
                    marginRight: "16px",
                    paddingRight: "8px",
                    textDecoration: "none",
                    color: "inherit",
                  }}
                >
                  List your Venue
                </div>
              )}

              <button
                onClick={() => {
                  navigate("/login");
                }}
                className="hidden lg:block text-white"
              >
                Login/Signup
              </button>

              {/* <Box
                sx={{
                  // display: { xs: "none", lg: "flex" },
                  alignItems: "center",
                  zIndex: 10,
                }}
                className="hidden lg:flex"
              >
                <IconButton onClick={handleOpenProfileMenu} sx={{ zIndex: 10 }}>
                  {user?.profilePic ? (
                    <>
                      <Box
                        component="img"
                        src={user?.profilePic}
                        alt="profile"
                        sx={{ height: 45, width: 45 }}
                        className="rounded-full"
                      />
                    </>
                  ) : (
                    <>
                      <Box
                        component="img"
                        src={profileIcon}
                        alt="profile"
                        sx={{ height: 45, width: 45 }}
                      />
                    </>
                  )}

                  <Box
                    component="img"
                    src={profileIcon2}
                    alt="profile"
                    className="ml-3"
                  />
                </IconButton>
                <Menu
                  anchorEl={anchorElProfile}
                  open={Boolean(anchorElProfile)}
                  onClose={handleCloseProfileMenu}
                  sx={{ zIndex: 11 }}
                  className="hidden lg:block"
                >
                  {isLoggedIn ? (
                    <MenuItem onClick={handleLogout}>Log Out</MenuItem>
                  ) : (
                    <MenuItem
                      component={Link}
                      to="/login"
                      onClick={handleCloseProfileMenu}
                    >
                      Log In
                    </MenuItem>
                  )}
                </Menu>
              </Box> */}

              <button
                className="lg:hidden block px-2"
                onClick={handleToggleNavigation}
              >
                {openNav ? (
                  <RxCross2 className="text-white text-3xl" />
                ) : (
                  <FiMenu className="text-white text-3xl" />
                )}
              </button>
              <MobileNavigation handleLogout={handleLogout} />
            </Box>
          </Toolbar>
          <NavPopup
            openPopup={openPopup}
            onClose={() => dispatch(togglePopup({ isOpen: false }))}
            subOptions={selectedSubOptions}
            selectedName={selectedName}
            handleToggleNavigation={handleToggleNavigation}
            setFilters={setFilters}
          />
        </Container>
      </AppBar>
    </>
  );
}

export default ResponsiveAppBar;
